"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSushiOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var XSushiOracleFactory = /** @class */ (function (_super) {
    __extends(XSushiOracleFactory, _super);
    function XSushiOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    XSushiOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    XSushiOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    XSushiOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    XSushiOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    XSushiOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return XSushiOracleFactory;
}(contracts_1.ContractFactory));
exports.XSushiOracleFactory = XSushiOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "CHAIN_LINK_DECIMALS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkTokenAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkTokenScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "sushi",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "xsushi",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
